import { ScopeEnum } from 'routes/types'
import CONFIGS from 'build/Config'
import { lazy, Suspense, ComponentType } from 'react'
import { routes as baseRoutes, Route } from './routes'

// Configuraciones específicas por versión
const routeConfigurations = {
  v1: {
    overrides: {}
  },
  v2: {
    overrides: {
      '/home': {
        component: 'HomeV3',
        scope: ScopeEnum.PUBLIC,
        notAgegate: false
      },
      '/': {
        component: 'HomeV3',
        scope: ScopeEnum.PUBLIC,
        notAgegate: false
      }
    }
  }
}

// Rutas excluidas por versión
const excludedRoutesByVersion = {
  v1: ['/events-info', '/events-info/:id'],
  v2: ['/login', '/end']
}

// Mapeo de componentes dinámicos
const dynamicComponents = {
  HomeV2: lazy(() => import('views/home/v2')),
  HomeV3: lazy(() => import('views/home/v3')),
  EventInfo: lazy(() => import('views/events-info'))
}

// Resolver componentes dinámicamente
const resolveComponent = (componentName: keyof typeof dynamicComponents) => {
  const Component = dynamicComponents[componentName] as ComponentType<any>
  if (!Component) {
    console.error(`Component ${componentName} not found`)
    return null
  }

  const ResolvedComponent = (props: React.ComponentProps<typeof Component>) => (
    <Suspense fallback={<div>Loading...</div>}>
      <Component {...props} />
    </Suspense>
  )

  ResolvedComponent.displayName = `Resolved${componentName}`
  return ResolvedComponent
}

// Configurar rutas dinámicamente según la versión
const configureRoutesByVersion = (routes: Route[], version: string) => {
  const config = routeConfigurations[version] || routeConfigurations.v1

  return routes.map((route) => {
    const override = config.overrides[route.path]

    if (override) {
      const { component, scope, notAgegate } = override

      return new Route(
        route.path,
        component ? resolveComponent(component) : route.component,
        scope || route.scope,
        route.exact,
        notAgegate
      )
    }

    return route
  })
}

// Obtener las rutas excluidas para la versión actual
const version = CONFIGS?.versionPh || 'v1'
const excludedRoutes = excludedRoutesByVersion[version] || []

// Filtrar rutas base para excluir las no deseadas según la versión
const filteredRoutes = baseRoutes.filter((route) => !excludedRoutes.includes(route.path))

// Configurar rutas dinámicamente según la versión
const configuredRoutes = configureRoutesByVersion(filteredRoutes, version)

export default configuredRoutes
